module.exports = __webpack_public_path__ + "img/model_change.e2e786b1.svg";